import { UseMutationOptions, useMutation } from "react-query";

import { AxiosRequestConfig, AxiosError } from "axios";
import http from "infra/http";
import { queryClient } from "infra/packages/react-query";
import { useInvalidateQuery } from "infra/packages/react-query";
import { showErrorAxios } from "infra/helpers/alerta";
import { CategoriaFinanceiraItem } from "features/condominio/hooks/useListFinancialCategory";

type IdNode<T> = { id?: string; key?: string; items: IdNode<T>[] | null };

function removeNode<T>(root: IdNode<T>[], item: IdNode<T>) {
  return root?.filter?.((node) => {
    if (node?.items) node.items = removeNode(node?.items, item);
    return node.id !== item.id || node.key !== item.key;
  });
}

export default function useDeleteFinancialCategory() {
  const { doInvalidateQueryWithStringKey } = useInvalidateQuery();

  const requestConfig: AxiosRequestConfig = {};
  const mutationOptions: UseMutationOptions<
    CategoriaFinanceiraItem,
    AxiosError,
    CategoriaFinanceiraItem,
    any
  > = {
    onSuccess: async (_, variables) => {
      doInvalidateQueryWithStringKey("/v1/tenants/passos-cadastro");

      // Cancela outras requisições
      await queryClient.cancelQueries("/v1/categoria-financeira");
      // Guarda o valor anterior
      const previous = queryClient.getQueryData<CategoriaFinanceiraItem[]>(
        "/v1/categoria-financeira"
      );

      // Remove o nó e retorna o novo valor
      const newValue = removeNode(previous ?? [], variables);
      // Adicionado o novo valor
      if (previous) {
        queryClient.setQueryData("/v1/categoria-financeira", [...newValue]);
      }

      return previous;
    },
    onError: (err: any, __: any, context: any) => {
      showErrorAxios(err);

      if (context?.previous) {
        queryClient.setQueryData("/v1/categoria-financeira", [
          ...context.previous,
        ]);
      }
    },
  };

  return useMutation(
    "delete/v1/categoria-financeira",
    async (body: CategoriaFinanceiraItem) => {
      if (body.id) {
        const { data } = await http.delete(
          `/v1/categoria-financeira/${body.id}`,
          requestConfig
        );
        return data;
      }
      return body;
    },
    mutationOptions
  );
}
